<template>
  <div class="main-body">
    <div class="header">温湿度设备</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini"  placeholder="输入Imei号" v-model="imei" clearable style="margin-right:5px;width:180px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="imei" label="Imei号" width="180"></el-table-column>

        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="150"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100px">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="viewData(scope.row)">数据</el-button>
            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>
    <Data ref="myData" v-show="showModalData" v-on:closeData="showModalData=false" v-on:getList="getList"></Data>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getGovernmentCode } from "@/utils/auth";

import Add from "./AddDisable";
import Data from "./Data";
import Elderly from "@/views/Elderly/Comm/ElderlyGovClass";

export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalData:false,
      showModalGetElderly:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",


    };
  },
  components:{
    Add, Elderly,Data
  },
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },


    viewData(row){
      this.showModalData = !this.showModalData;
      this.$refs.myData.init(row);
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceTemp/PageByGovCodeClassName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          userCode: this.userCode,
          imei: this.imei,
          elderlyClassName:'残疾人',
        },
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceTemp/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceTempCode: row.deviceTempCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消操作",});
      });
    },

  },
};
</script>

<style scoped>
</style>
